import ActiveBonusProgressBar from './ActiveBonusProgressBar';

export default ActiveBonusProgressBar;
